module.exports = "/images/info.svg?73dc74ad86ea24b88cc11738f000f472";